import { render, staticRenderFns } from "./PodcastPublicationStatus.vue?vue&type=template&id=50710300"
import script from "./PodcastPublicationStatus.vue?vue&type=script&lang=js"
export * from "./PodcastPublicationStatus.vue?vue&type=script&lang=js"
import style0 from "./PodcastPublicationStatus.vue?vue&type=style&index=0&id=50710300&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports